import { ensureGoogleMapsLoaded } from "./googleMapsLoader";
import { RegionOwnerAddress } from "./LocationPicker";

export const fetchPlace = async (placeId: string): Promise<RegionOwnerAddress | undefined> => {
  await ensureGoogleMapsLoaded();

  const placeService = new google.maps.places.Place({ id: placeId });
  try {
    const details = await placeService.fetchFields({
      fields: ["addressComponents", "location", "types"],
    });
    const placeDetails = details.place;

    if (placeDetails) {
      const addressComponents = placeDetails.addressComponents;
      if (addressComponents) {
        const country = addressComponents.find((component) => component.types.includes("country"))?.longText || "";
        const city = addressComponents.find((component) => component.types.includes("locality"))?.longText || "";
        const street = addressComponents.find((component) => component.types.includes("route"))?.longText || "";
        const streetNumber = addressComponents.find((component) => component.types.includes("street_number"))?.longText;
        const postalCode =
          addressComponents.find((component) => component.types.includes("postal_code"))?.longText || "";
        const latitude = placeDetails.location ? placeDetails.location.lat() : null;
        const longitude = placeDetails.location ? placeDetails.location.lng() : null;

        if (!latitude || !longitude) {
          throw new Error("Latitude or longitude is missing");
        }

        const updatedAddress: RegionOwnerAddress = {
          country,
          city,
          street: street + (streetNumber ? ` ${streetNumber}` : ""),
          postalCode,
          latitude,
          longitude,
        };

        return updatedAddress;
      }
    }
    return undefined;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error occurred while fetching place details:", error);
    return undefined;
  }
};
